export interface Brand {
  id: string;
  name: string;
  slogan: string;
  description: string;
  category: string;
  tags: string[];
  rating: number;
  foundedYear: number;
  image: string;
  website: string;
  featured: boolean;
}

export const brands: Brand[] = [
  {
    id: 'huawei',
    name: '华为',
    slogan: '构建万物互联的智能世界',
    description: '华为是全球领先的ICT基础设施和智能终端提供商，致力于把数字世界带入每个人、每个家庭、每个组织。华为在5G、人工智能、云计算等领域持续引领全球科技创新，是中国高科技走向世界的标杆企业，以自主创新精神和卓越品质赢得全球170多个国家和地区的客户信赖。',
    category: 'keji-shuma',
    tags: ['5G技术', '智能手机', '鸿蒙系统', '云计算'],
    rating: 4.9,
    foundedYear: 1987,
    image: 'https://readdy.ai/api/search-image?query=Huawei%20technology%20headquarters%20modern%20architecture%20with%20warm%20sunset%20lighting%2C%20professional%20corporate%20photography%2C%20clean%20minimalist%20composition%2C%20glass%20building%20reflection%2C%20innovative%20tech%20atmosphere&width=800&height=600&seq=huawei-brand-01&orientation=landscape',
    website: 'https://www.huawei.com',
    featured: true,
  },
  {
    id: 'xiaomi',
    name: '小米',
    slogan: '让每个人都能享受科技的乐趣',
    description: '小米是一家以手机、智能硬件和IoT平台为核心的互联网公司。始终坚持做感动人心、价格厚道的好产品，让全球每个人都能享受科技带来的美好生活。小米已经建成全球最大的消费级IoT平台，连接设备数超过6亿台，是中国科技企业创新模式的成功典范。',
    category: 'keji-shuma',
    tags: ['智能手机', 'IoT平台', '智能家居', '性价比'],
    rating: 4.7,
    foundedYear: 2010,
    image: 'https://readdy.ai/api/search-image?query=Xiaomi%20technology%20store%20modern%20interior%20with%20smart%20devices%20display%2C%20bright%20clean%20minimalist%20design%2C%20warm%20white%20lighting%2C%20product%20showcase%20professional%20photography&width=800&height=600&seq=xiaomi-brand-02&orientation=landscape',
    website: 'https://www.mi.com',
    featured: true,
  },
  {
    id: 'byd',
    name: '比亚迪',
    slogan: '用技术创新，满足人们对美好生活的向往',
    description: '比亚迪是全球领先的新能源汽车制造商，掌握电池、电机、电控等新能源汽车全产业链核心技术。从刀片电池到DM-i超级混动，比亚迪以持续的技术突破推动全球汽车产业变革。2023年比亚迪新能源汽车销量突破300万辆，成为中国汽车工业崛起的最佳见证。',
    category: 'qiche',
    tags: ['新能源汽车', '刀片电池', '中国智造', '绿色出行'],
    rating: 4.8,
    foundedYear: 1995,
    image: 'https://readdy.ai/api/search-image?query=BYD%20electric%20vehicle%20modern%20showroom%20with%20clean%20futuristic%20design%2C%20sleek%20car%20display%2C%20bright%20professional%20lighting%2C%20automotive%20photography%20with%20warm%20atmosphere&width=800&height=600&seq=byd-brand-03&orientation=landscape',
    website: 'https://www.byd.com',
    featured: true,
  },
  {
    id: 'dji',
    name: '大疆创新',
    slogan: '未来无所不能',
    description: '大疆创新是全球领先的无人机及航拍技术公司，以"未来无所不能"为理念，持续推动飞行影像系统的技术革新。大疆占据全球消费级无人机市场超过70%的份额，产品广泛应用于影视航拍、农业植保、公共安全等领域，是中国科技创新企业在全球细分市场做到极致的典范。',
    category: 'keji-shuma',
    tags: ['无人机', '航拍', '机器人', '全球领先'],
    rating: 4.9,
    foundedYear: 2006,
    image: 'https://readdy.ai/api/search-image?query=DJI%20drone%20innovation%20center%20modern%20tech%20laboratory%2C%20professional%20corporate%20environment%2C%20clean%20white%20interior%20with%20drone%20display%2C%20bright%20natural%20lighting%2C%20technological%20atmosphere&width=800&height=600&seq=dji-brand-04&orientation=landscape',
    website: 'https://www.dji.com',
    featured: true,
  },
  {
    id: 'lining',
    name: '李宁',
    slogan: '一切皆有可能',
    description: '李宁是中国领先的体育品牌，以体操王子李宁先生命名。品牌将中国文化与现代运动科技完美融合，以"中国李宁"系列引领国潮风尚，登上纽约时装周、巴黎时装周等国际舞台。李宁用创新设计诠释东方美学，让世界看到中国运动品牌的力量与态度。',
    category: 'fushi-xiebao',
    tags: ['运动品牌', '国潮', '中国设计', '时装周'],
    rating: 4.6,
    foundedYear: 1990,
    image: 'https://readdy.ai/api/search-image?query=Li-Ning%20sports%20brand%20modern%20flagship%20store%20with%20Chinese%20design%20elements%2C%20athletic%20apparel%20display%2C%20warm%20professional%20lighting%2C%20clean%20minimalist%20retail%20space&width=800&height=600&seq=lining-brand-05&orientation=landscape',
    website: 'https://www.lining.com',
    featured: true,
  },
  {
    id: 'haier',
    name: '海尔',
    slogan: '真诚到永远',
    description: '海尔是全球大型家电第一品牌，连续14年蝉联全球大型家用电器品牌零售量第一。海尔以用户需求为核心，打造卡萨帝、统帅等多品牌矩阵，在全球建立10大研发中心，产品销往200多个国家和地区，是中国制造品质和服务的标杆企业。',
    category: 'jiadian',
    tags: ['智能家电', '全球第一', '品质制造', '卡萨帝'],
    rating: 4.7,
    foundedYear: 1984,
    image: 'https://readdy.ai/api/search-image?query=Haier%20smart%20home%20experience%20center%20modern%20interior%20design%2C%20kitchen%20appliances%20display%2C%20bright%20warm%20lighting%2C%20professional%20showroom%20photography%2C%20clean%20minimalist%20composition&width=800&height=600&seq=haier-brand-06&orientation=landscape',
    website: 'https://www.haier.com',
    featured: false,
  },
  {
    id: 'hua-xizi',
    name: '花西子',
    slogan: '以花养妆，东方彩妆',
    description: '花西子是中国高端彩妆品牌，以"东方彩妆，以花养妆"为理念，将中国传统美学与现代彩妆科技完美结合。品牌以苗族银饰、西湖十景等中国文化元素为设计灵感，产品远销全球100多个国家和地区，让世界爱上中国彩妆，是中国美妆品牌出海的杰出代表。',
    category: 'meizhuang',
    tags: ['东方彩妆', '国货之光', '高端美妆', '文化传承'],
    rating: 4.8,
    foundedYear: 2017,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20luxury%20cosmetics%20brand%20elegant%20display%20with%20traditional%20Chinese%20design%20elements%2C%20warm%20soft%20lighting%2C%20delicate%20floral%20aesthetics%2C%20modern%20minimalist%20composition&width=800&height=600&seq=huaxizi-brand-07&orientation=landscape',
    website: 'https://www.huaxizi.com',
    featured: false,
  },
  {
    id: 'yuanqi-senlin',
    name: '元气森林',
    slogan: '0糖0脂0卡，好喝不怕胖',
    description: '元气森林是中国新消费品牌的标杆，以"用户第一"为核心理念，开创性地将赤藓糖醇等天然代糖应用于饮料产品，重新定义了中国饮料行业。品牌以互联网思维做产品，坚持极致的用户体验和产品创新，仅用5年时间估值突破千亿，是新国货崛起的现象级案例。',
    category: 'shipin-yinliao',
    tags: ['新消费', '健康饮品', '国货新锐', '互联网思维'],
    rating: 4.5,
    foundedYear: 2016,
    image: 'https://readdy.ai/api/search-image?query=Modern%20beverage%20brand%20display%20with%20fresh%20natural%20aesthetics%2C%20clean%20white%20background%2C%20minimalist%20product%20photography%2C%20vibrant%20fruit%20elements%2C%20bright%20professional%20studio%20lighting&width=800&height=600&seq=yuanqi-brand-08&orientation=landscape',
    website: 'https://www.yuanqisenlin.com',
    featured: false,
  },
  {
    id: 'anta',
    name: '安踏',
    slogan: '永不止步 Keep Moving',
    description: '安踏是中国最大的体育用品集团，旗下拥有安踏、斐乐、迪桑特、始祖鸟等多个知名品牌。通过持续的技术创新和多品牌战略，安踏已成为全球市值第三的运动品牌集团。安踏始终坚持以科技创新驱动品牌发展，累计获得超2000项专利，是中国体育产业当之无愧的领军企业。',
    category: 'fushi-xiebao',
    tags: ['运动品牌', '多品牌战略', '科技创新', '全球领先'],
    rating: 4.7,
    foundedYear: 1991,
    image: 'https://readdy.ai/api/search-image?query=Anta%20sports%20brand%20modern%20flagship%20store%20interior%2C%20athletic%20footwear%20display%2C%20dynamic%20sports%20atmosphere%2C%20bright%20professional%20lighting%2C%20clean%20retail%20design%20photography&width=800&height=600&seq=anta-brand-09&orientation=landscape',
    website: 'https://www.anta.com',
    featured: false,
  },
  {
    id: 'nongfu-spring',
    name: '农夫山泉',
    slogan: '我们不生产水，我们只是大自然的搬运工',
    description: '农夫山泉是中国包装饮用水及饮料行业的龙头企业，坚持水源地建厂、水源地灌装的生产理念。品牌以"天然、健康"为核心价值，拥有浙江千岛湖、吉林长白山等12大优质水源地。农夫山泉以高品质产品赢得数亿中国消费者的长期信赖，是中国消费品品牌建设的经典案例。',
    category: 'shipin-yinliao',
    tags: ['天然水源', '健康饮品', '国民品牌', '品质坚守'],
    rating: 4.6,
    foundedYear: 1996,
    image: 'https://readdy.ai/api/search-image?query=Nongfu%20Spring%20natural%20water%20source%20mountain%20landscape%2C%20pristine%20nature%20with%20forest%20and%20lake%2C%20crystal%20clear%20water%2C%20professional%20landscape%20photography%2C%20warm%20natural%20lighting&width=800&height=600&seq=nongfu-brand-10&orientation=landscape',
    website: 'https://www.nongfuspring.com',
    featured: false,
  },
  {
    id: 'gree',
    name: '格力',
    slogan: '让世界爱上中国造',
    description: '格力电器是全球最大的专业化空调企业，掌握核心科技。格力以自主创新为核心驱动力，累计申请专利超过10万项，自主研发的磁悬浮变频离心式冷水机组等产品达到国际领先水平。格力以卓越品质和技术实力向世界证明了中国制造的高度，是中国制造业转型升级的标杆。',
    category: 'jiadian',
    tags: ['核心科技', '自主创新', '中国制造', '全球领先'],
    rating: 4.7,
    foundedYear: 1991,
    image: 'https://readdy.ai/api/search-image?query=Gree%20electric%20appliance%20manufacturing%20modern%20clean%20factory%2C%20professional%20industrial%20photography%2C%20bright%20white%20lighting%2C%20advanced%20production%20line%2C%20technology%20innovation%20atmosphere&width=800&height=600&seq=gree-brand-11&orientation=landscape',
    website: 'https://www.gree.com',
    featured: false,
  },
  {
    id: 'nio',
    name: '蔚来',
    slogan: 'Blue Sky Coming',
    description: '蔚来是全球领先的智能电动汽车品牌，致力于为用户创造愉悦的生活方式。蔚来以换电模式、NIO House用户社区和极致的服务体验重新定义了汽车品牌与用户的关系。蔚来在德国、英国等全球多地设立研发中心，是中国高端智能电动汽车出海的先行者和引领者。',
    category: 'qiche',
    tags: ['智能电动', '换电模式', '用户社区', '高端品牌'],
    rating: 4.6,
    foundedYear: 2014,
    image: 'https://readdy.ai/api/search-image?query=NIO%20electric%20car%20experience%20center%20modern%20minimalist%20design%2C%20futuristic%20showroom%20interior%2C%20bright%20clean%20lighting%2C%20premium%20automotive%20photography%2C%20lifestyle%20atmosphere&width=800&height=600&seq=nio-brand-12&orientation=landscape',
    website: 'https://www.nio.com',
    featured: false,
  },
  {
    id: 'iflytek',
    name: '科大讯飞',
    slogan: '用人工智能建设美好世界',
    description: '科大讯飞是亚太地区知名的智能语音和人工智能上市企业，在语音识别、语音合成、自然语言处理等领域拥有国际领先的核心技术。科大讯飞的AI技术已广泛应用于教育、医疗、司法、智慧城市等领域，产品覆盖全球200多个国家和地区，是中国AI技术走向世界的杰出代表。',
    category: 'keji-shuma',
    tags: ['人工智能', '语音识别', 'AI技术', '全球领先'],
    rating: 4.8,
    foundedYear: 1999,
    image: 'https://readdy.ai/api/search-image?query=iFlytek%20AI%20technology%20office%20modern%20interior%20with%20digital%20displays%2C%20smart%20devices%2C%20clean%20minimalist%20corporate%20environment%2C%20bright%20natural%20lighting%2C%20innovative%20tech%20atmosphere&width=800&height=600&seq=iflytek-brand-13&orientation=landscape',
    website: 'https://www.iflytek.com',
    featured: false,
  },
  {
    id: 'perfect-diary',
    name: '完美日记',
    slogan: '中国美，正当红',
    description: '完美日记是中国新锐彩妆品牌的领导者，以互联网DTC模式重新定义了中国美妆消费。品牌以"高品质、高性价比"为核心竞争力，与迪士尼、大英博物馆等国际IP跨界联名，创下多个销售纪录。完美日记母公司逸仙电商已成功在纽交所上市，是中国美妆新消费模式走向国际的先行者。',
    category: 'meizhuang',
    tags: ['新锐彩妆', 'DTC模式', '国货美妆', '跨界联名'],
    rating: 4.5,
    foundedYear: 2017,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20cosmetics%20brand%20modern%20elegant%20display%2C%20minimalist%20beauty%20product%20photography%2C%20soft%20warm%20lighting%2C%20luxurious%20aesthetic%2C%20clean%20composition%20with%20floral%20accents&width=800&height=600&seq=perfectdiary-brand-14&orientation=landscape',
    website: 'https://www.perfectdiary.com',
    featured: false,
  },
  {
    id: 'midea',
    name: '美的',
    slogan: '科技尽善，生活尽美',
    description: '美的集团是全球最大的家电制造商之一，业务覆盖消费电器、暖通空调、机器人与自动化系统等多元领域。美的在全球拥有31个研发中心和40个主要生产基地，产品出口至全球200多个国家和地区。美的以数字化转型和科技创新驱动企业持续成长，是传统制造业智能化升级的成功典范。',
    category: 'jiadian',
    tags: ['智能家居', '全球制造', '数字化转型', '机器人'],
    rating: 4.7,
    foundedYear: 1968,
    image: 'https://readdy.ai/api/search-image?query=Midea%20smart%20home%20appliance%20showroom%20modern%20interior%2C%20kitchen%20and%20home%20devices%20display%2C%20bright%20clean%20lighting%2C%20professional%20product%20photography%2C%20minimalist%20design&width=800&height=600&seq=midea-brand-15&orientation=landscape',
    website: 'https://www.midea.com',
    featured: false,
  },
  {
    id: 'bosideng',
    name: '波司登',
    slogan: '世界名牌，温暖世界',
    description: '波司登是全球领先的羽绒服专家，连续28年中国市场销量第一，产品畅销美国、法国、意大利等72个国家。波司登以国际设计师联名和高品质面料持续引领羽绒服时尚趋势，多次亮相纽约、米兰、伦敦时装周。波司登用中国品质温暖世界，是中国服装品牌走向全球的骄傲。',
    category: 'fushi-xiebao',
    tags: ['羽绒服', '全球品牌', '中国品质', '时装周'],
    rating: 4.7,
    foundedYear: 1976,
    image: 'https://readdy.ai/api/search-image?query=Bosideng%20down%20jacket%20modern%20flagship%20store%20interior%2C%20winter%20fashion%20display%2C%20warm%20ambiance%20lighting%2C%20professional%20retail%20photography%2C%20clean%20minimalist%20composition&width=800&height=600&seq=bosideng-brand-16&orientation=landscape',
    website: 'https://www.bosideng.com',
    featured: false,
  },
  {
    id: 'sanzhisongshu',
    name: '三只松鼠',
    slogan: '让天下主人爽起来',
    description: '三只松鼠是中国坚果零食行业的领导品牌，以互联网电商模式开创了中国零食行业新格局。品牌以萌趣IP形象和年轻化营销俘获了亿万年轻消费者，连续多年蝉联全网坚果销量冠军。三只松鼠以"造货+造体验"的双轮驱动模式，重新定义了中国休闲零食的消费体验。',
    category: 'shipin-yinliao',
    tags: ['零食品牌', '互联网模式', 'IP营销', '年轻化'],
    rating: 4.4,
    foundedYear: 2012,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20snack%20brand%20modern%20display%20with%20playful%20design%2C%20colorful%20packaging%2C%20bright%20warm%20studio%20lighting%2C%20professional%20product%20photography%2C%20clean%20minimalist%20composition&width=800&height=600&seq=sanzhisongshu-brand-17&orientation=landscape',
    website: 'https://www.3songshu.com',
    featured: false,
  },
  {
    id: 'li-xiang',
    name: '理想汽车',
    slogan: '创造移动的家，创造幸福的家',
    description: '理想汽车是中国领先的新能源汽车制造商，以增程式电动技术开创了独特的市场定位。理想汽车以"创造移动的家"为品牌使命，专注为中国家庭打造高品质的智能出行体验。理想L系列车型持续热销，成为中国中大型SUV市场的销量冠军，展现了国产高端汽车品牌的强大竞争力。',
    category: 'qiche',
    tags: ['增程电动', '家庭用车', '智能出行', '高端SUV'],
    rating: 4.7,
    foundedYear: 2015,
    image: 'https://readdy.ai/api/search-image?query=Li%20Auto%20electric%20SUV%20modern%20showroom%20with%20family-oriented%20design%2C%20clean%20minimalist%20interior%2C%20bright%20professional%20lighting%2C%20premium%20automotive%20photography%2C%20warm%20atmosphere&width=800&height=600&seq=lixiang-brand-18&orientation=landscape',
    website: 'https://www.lixiang.com',
    featured: false,
  },
];